'use client';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import logo from '../../assets/images/logoDark.webp';
import useModal from '@/hooks/useModal';
import { MODAL_NAMES } from '@/constants/modals';
import styles from './FormHeader.module.scss';

interface Props {
  hiddenText?: boolean;
  hiddenAdDisclosure?: boolean;
}

interface InnerProps extends Props {
  pathname: string;
}

const InnerOfferWallHeader = ({
  pathname,
  hiddenText,
  hiddenAdDisclosure,
}: InnerProps) => {
  const searchParams = useSearchParams();
  const { openModal } = useModal();
  const loading = searchParams.get('loading');
  const isDefaultHeader =
    pathname.includes('result') ||
    loading ||
    pathname.includes('error') ||
    pathname.includes('special') ||
    pathname.includes('agent') ||
    hiddenText ||
    pathname.includes('booking') ||
    pathname.includes('pennie') ||
    pathname.includes('/my-offers/tri-point') ||
    pathname.includes('/referral') ||
    pathname.includes('/get-offers') ||
    pathname.includes('/summary-analysis') ||
    pathname.includes('/submitted') ||
    pathname.includes('5kf') ||
    pathname.includes('portal') ||
    pathname.includes('offerhub') ||
    pathname.includes('call-me-now');

  const hideAdDisclosure = loading || hiddenAdDisclosure;

  return (
    <header
      className={`${styles.wrapper} ${hiddenAdDisclosure ? styles.emptyHeader : ''}`}
    >
      <div className={styles.content}>
        <Link href="/" aria-label="home page">
          <Image src={logo} alt="logo" className={styles.logo} />
        </Link>
        {!hideAdDisclosure && (
          <span
            onClick={() => openModal({ name: MODAL_NAMES.adDisclosure })}
            className={styles.disclosureButton}
          >
            Ad Disclosure
          </span>
        )}
      </div>
      {!isDefaultHeader && (
        <p className={styles.subtitle}>
          Offer order is based on conversion probability, partner compensation,
          and other actors.
        </p>
      )}
    </header>
  );
};

const OfferWallHeader = ({
  hiddenText = false,
  hiddenAdDisclosure = false,
}: Props) => {
  const pathname = usePathname();

  return (
    <Suspense fallback={null}>
      <InnerOfferWallHeader
        pathname={pathname}
        hiddenText={hiddenText}
        hiddenAdDisclosure={hiddenAdDisclosure}
      />
    </Suspense>
  );
};

export default OfferWallHeader;
